import Space from "../../../Common/Space";
import React from "react";
import {MobileContainer} from "../../../Global/Global";
import SearchBar from "../SearchBar";
import BreadCrumbs from "../../../BreadCrumbs/Breadcrumbs";
import Divider from "../../../Common/Divider";
import Column from "../../../Common/Column";
import {Tabs, Typography} from "@mui/material";
import {PriceFilterMobile} from "./PriceFilterMobile";
import {LocationFilterMobile} from "./LocationFilterMobile";
import {CategoryFilterMobile} from "./CategoryFilterMobile";
import {CustomFiltersMobile} from "./CustomFiltersMobile";
import {categoryStore} from "../../../../Stores/CategoryStore";
import {observer} from "mobx-react-lite";

const FilterBoxes = observer(() => {
    return <MobileContainer>
        <Column sx={{paddingTop: "10px"}}>
            <Typography sx={{fontWeight: "bold"}}>Filtre</Typography>
            <Space height="5px"/>

            {categoryStore.isInitialized && (
                <Tabs value={false} variant="scrollable" scrollButtons={false}>
                    <PriceFilterMobile />
                    <LocationFilterMobile/>
                    <CustomFiltersMobile/>
                </Tabs>
            )}

            <Space height="5px"/>
        </Column>
        <Space height="10px"/>
    </MobileContainer>
})

export const FiltersMobile = () => {
    return <>
        <MobileContainer>
            <SearchBar sx={{margin: "20px 0"}}/>
            <BreadCrumbs sx={{paddingTop: "5px"}}/>
        </MobileContainer>

        <CategoryFilterMobile/>
        <Space height="5px"/>
        <Divider/>
        <FilterBoxes/>
    </>
}
